import React, { ChangeEvent, useEffect, useState } from 'react';
import {
    useProperty,
    usePropertyDescriptionDetail,
} from '../../../../contextsProperty/ContextProperties';
import LateralPanel from '../../../../../muiComponents/LateralPanel';
import Title from '../../Title';
import Icon from '../../../../../muiComponents/Icon';
import TextInput from '../../../../../muiComponents/TextInput/TextInput';
import Button from '../../../../../muiComponents/Button';
import useTranslate from '../../../../../customHooks/useTranslate';
import { Alert, AlertTitle } from '@mui/material';
import Flag from '../../../components/Flag';
import Label from '../../Label';
import { DESCRIPTION_DEATIL_INITIAL_STATE } from '../../../../../utils/property/propertyUtils';
import { DescriptionState } from '../../../../../types/properties/propertyTypes';
import DeletePopUp from '../../DeletePopUp';

const NewDescriptionPanel = () => {
    const translate = useTranslate();
    const { modidyCollectionItem } = useProperty();
    const {
        id,
        idLanguage,
        languageCode,
        language,
        descriptionContent,
        isOpenPanel,
        handleDescriptionDetailChange,
        getAIDescription,
        isLoadingAIDescriptionAssistant,
        AIDescriptionAnswer,
        resetAIDescriptionAssistant,
    } = usePropertyDescriptionDetail();
    const [error, setError] = useState('');
    const [isDeletePopUpVisible, setIsDeletePopUpVisible] = useState(false);

    const cancelPanel = () => {
        handleDescriptionDetailChange(DESCRIPTION_DEATIL_INITIAL_STATE);
        resetAIDescriptionAssistant();
    };

    const handleSave = () => {
        if (!descriptionContent) {
            setError(translate('required'));
            return;
        }
        setError('');
        const action = parseInt(id) < 0 ? 'add' : 'update';
        modidyCollectionItem('descriptions', action, {
            id,
            idLanguage,
            languageCode,
            language,
            descriptionContent,
        });
        cancelPanel();
    };

    useEffect(() => {
        if (AIDescriptionAnswer) {
            handleDescriptionDetailChange({
                descriptionContent: AIDescriptionAnswer,
                __isChanged: true,
            });
        }
    }, [AIDescriptionAnswer]);

    return (
        <>
            <LateralPanel
                open={isOpenPanel}
                className='flex-column gap-20 properties-description__panel'
            >
                <header className='flex flex-between flex-align-center padding-inline50'>
                    <Title
                        text='Add description'
                        className='text-secondary-color'
                    />
                    <Icon
                        iconName='Close'
                        className='cursor-pointer'
                        onClick={() =>
                            !isLoadingAIDescriptionAssistant && cancelPanel()
                        }
                    />
                </header>
                <main className='flex-column gap-30 height100perc overflow-y-auto padding-inline50'>
                    <Alert severity='info'>
                        <div className='flex-column gap-20'>
                            <div className='flex-column gap-10'>
                                <AlertTitle sx={{ fontWeight: 'bold' }}>
                                    {translate('description_ai_alert_title')}
                                </AlertTitle>
                                <p style={{ fontWeight: 'normal' }}>
                                    {translate('description_ai_alert_text')}
                                </p>
                            </div>
                            <Button
                                className='width-content'
                                variant='contained'
                                startIcon={'AutoFixHigh'}
                                disabled={isLoadingAIDescriptionAssistant}
                                onClick={() => getAIDescription(language)}
                            >
                                {translate(
                                    isLoadingAIDescriptionAssistant
                                        ? 'description_ai_button_loading'
                                        : 'edit_AI_description'
                                )}
                            </Button>
                        </div>
                    </Alert>
                    <div className='flex-column gap-10'>
                        <div className='flex flex-between flex-align-baseline'>
                            <Label text='description2' translated />
                            <div className='flex flex-align-center gap-10'>
                                <Flag code={languageCode} text={language} />
                                <p>{language}</p>
                            </div>
                        </div>
                        <TextInput
                            multiline
                            rows={20}
                            value={descriptionContent}
                            disabled={isLoadingAIDescriptionAssistant}
                            handleChange={(
                                e: ChangeEvent<HTMLTextAreaElement>
                            ) =>
                                handleDescriptionDetailChange({
                                    descriptionContent: e.target.value,
                                    __isChanged: true,
                                })
                            }
                            error={!!error}
                            errorMessage={error}
                        />
                    </div>
                </main>
                <footer className='flex flex-between padding-inline50'>
                    <Button
                        variant='contained'
                        className={
                            !isLoadingAIDescriptionAssistant
                                ? 'properties__delete-button'
                                : undefined
                        }
                        disabled={isLoadingAIDescriptionAssistant}
                        onClick={() => {
                            setIsDeletePopUpVisible(true);
                        }}
                    >
                        {translate('delete')}
                    </Button>
                    <div className='flex gap-20'>
                        <Button
                            variant='outlined'
                            disabled={isLoadingAIDescriptionAssistant}
                            onClick={cancelPanel}
                        >
                            {translate('cancel')}
                        </Button>
                        <Button
                            variant='contained'
                            disabled={isLoadingAIDescriptionAssistant}
                            onClick={handleSave}
                        >
                            {translate('save')}
                        </Button>
                    </div>
                </footer>
            </LateralPanel>
            {isDeletePopUpVisible && (
                <DeletePopUp
                    open={!!isDeletePopUpVisible}
                    onSave={() => {
                        modidyCollectionItem('descriptions', 'delete', {
                            id,
                        } as DescriptionState);
                        setIsDeletePopUpVisible(false);
                        cancelPanel();
                    }}
                    onCancel={() => {
                        setIsDeletePopUpVisible(false);
                        cancelPanel();
                    }}
                />
            )}
        </>
    );
};

export default NewDescriptionPanel;
